module.exports = __webpack_public_path__ + "images/autoexpert05ee934a1bcf0c3cc889c70a248cb31d.png";